import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import type { UserRole } from '@spi/shared';

interface RoleGuardProps {
  roles: UserRole[];
  children: React.ReactNode;
}

export function RoleGuard({ roles, children }: RoleGuardProps) {
  const { user, realUser, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-spi-green border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/marketplace/login" replace />;
  }

  // Allow if effective role matches OR if real user is admin (impersonation)
  const effectiveRole = user!.role;
  const isRealAdmin = realUser?.role === 'admin';

  if (!roles.includes(effectiveRole) && !isRealAdmin) {
    return <Navigate to="/marketplace/dashboard" replace />;
  }

  return <>{children}</>;
}
